import { actionNames } from './constants'

export type ActionNames = (typeof actionNames)[number]
export type Action = VoidFunction

const store = new Map<ActionNames, Action>()

export const registerAction = (name: ActionNames, action: Action) => {
  store.set(name, action)
}

export const deleteAction = (name: ActionNames) => {
  store.delete(name)
}

/** Return `true` if action is triggered */
export const triggerAction = (name: ActionNames) => {
  const action = store.get(name)

  deleteAction(name)

  if (!action) return false

  action()

  return true
}
